export default __webpack_public_path__ + "static/media/lung_plot_male.07e91906.png";